module.exports = __webpack_public_path__ + "static/media/rgs_clinic_pc.8c56a29b.png";